<template>
    <v-form ref="registrationForm" lazy-validation>
        <v-card>
            <v-card-title>
                Registration Form
                <v-spacer></v-spacer>
                <v-btn icon @click="closeForm()">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-subtitle style="font-weight:bold">Event: {{event_title}}</v-card-subtitle>
            <v-card-text>
                <v-row>
                    <v-col cols="12" xs="6" md="6">
                        <v-text-field v-model="firstname" :rules="[rules.required]" label="First Name*">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" xs="6" md="6">
                        <v-text-field v-model="lastname" :rules="[rules.required]" label="Last Name*">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-text-field v-model="registration.email" :rules="[rules.email,rules.required]" label="E-mail*">
                </v-text-field>
                <v-text-field v-model="registration.phone" :rules="[rules.required]" label="Phone*"></v-text-field>
                <v-text-field v-model="registration.company_name" :rules="[rules.required]" label="Organisation Name*">
                </v-text-field>
                <v-text-field v-model="registration.company_address1"
                    label="Organisation Address 1"></v-text-field>
                <v-text-field v-model="registration.company_address2" label="Organisation Address 2"></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-btn style="width:100%" color="success" @click="addRegistration()" :loading="loading">Register</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>

</template>

<script>
import eventService from '../services/event.service';
//import emailService from '../services/email.service'
export default {
    props: {
        event_id: String,
        event_title: String,
        approv_type: String,
    },
    data: () => ({
        loading: false,
        firstname:"",
        lastname:"",
        rules: {
            required: value => !!value || 'Required.',
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
            }
        },
        registration: {
            name: "",
            email: "",
            phone: "",
            company_name: "",
            company_address1: "",
            company_address2: "",
            company_website: "",
            approval_status: "pending",
            checkin_dates: [],
            registrationDate: new Date().toISOString()
        },
        registrationcp: {
            name: "",
            email: "",
            phone: "",
            company_name: "",
            company_address1: "",
            company_address2: "",
            company_website: "",
            approval_status: "pending",
            checkin_dates: [],
            registrationDate: new Date().toISOString()
        }
    }),
    methods: {
        async addRegistration() {
            if (!this.$refs.registrationForm.validate()) {
                return
            }
            this.loading = true
            this.registration.approval_status = (this.approv_type == "manual" ? "pending" : "approved");
            this.registration.name = this.firstname+" "+this.lastname

            await eventService.addEventRegistration(this.event_id, this.registration).then(() => {
                this.$toast.success(`Thank you for registering for ${this.event_title}. Please expect additional details about this event in your e-mail shortly.`, { duration: 6000 })
                // if(this.approv_status=="approved"){
                //     emailService.sendEmail(this.registration.name,this.registration.email,this.event_title)
                // }
                Object.assign(this.registration, this.registrationcp)
                this.firstname=""
                this.lastname=""
                this.closeForm()
            }).catch(err => {
                console.log(err)
                if (err == "Error: email_exist") {
                    this.$toast.warning("A registration with this email address already exist")

                } else {
                    this.$toast.error("An error occured and event registration could not be added")
                }

            })
            this.loading = false
        },
        closeForm() {
            this.$emit('close-form')
        }
    }
}
</script>